// extracted by mini-css-extract-plugin
module.exports = {"button":"_2tP3B"};